import React, { useState } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';

import cnIcon1 from '../../../images/icons/icon_php.svg'
import cnIcon2 from '../../../images/icons/icon_javascript.svg'
import cnIcon3 from '../../../images/case/icon_elephent.svg'
import cnIcon4 from '../../../images/icons/icon_swift.svg'
import cnIcon5 from '../../../images/icons/icon_typescript.svg'
import cnIcon6 from '../../../images/icons/icon_python.svg'
import cnIcon7 from '../../../images/icons/icon_g318.svg'
import cnIcon8 from '../../../images/icons/icon_java.svg'
import cnIcon9 from '../../../images/icons/icon_ruby.svg'
import cnIcon10 from '../../../images/icons/icon_c_plus.svg'
import cnIcon11 from '../../../images/icons/icon_react_js.svg'
import cnIcon12 from '../../../images/icons/icon_laravel.svg'
import Bg from '../../../images/shapes/shape_title_under_line.svg'


import TerraNet from '../../../images/clients/TerraNet.png'
import Ruijie from '../../../images/clients/Ruijie.png'
import OMNIA from '../../../images/clients/OMNIA.png'
import NextMove from '../../../images/clients/Nextmove.png'
import Moratelindo from '../../../images/clients/Moratelindo.png'
import Maipu from '../../../images/clients/maipu.png'
import Holowits from '../../../images/clients/holowits.png'
import Ceragon from '../../../images/clients/ceragon.png'

import iso_9001 from '../../../images/clients/iso_9001.png'
import ISO_45001 from '../../../images/clients/ISO_45001.png'
import ISO_14001 from '../../../images/clients/ISO_14001.png'
import IDC_Duren_3 from '../../../images/clients/IDC_Duren_3.jpeg'
import iconplus from '../../../images/clients/iconplus.png'
import Huawei from '../../../images/clients/Huawei.png'
import CGSwarna from '../../../images/clients/CGS-Warna.png'
import CambiumNet from '../../../images/clients/CambiumNet.png'
import Indosat from '../../../images/clients/Indosat.png'
import imageDefault from '../../../images/clients/default.png'


const TechnologyList = [
    {
        Id: '1',
        sIcon: CambiumNet,
        title: 'Cambium Network',
    },
    {
        Id: '2',
        sIcon: Ruijie,
        title: 'Ruijie Network',
    },
    {
        Id: '3',
        sIcon: NextMove,
        title: 'Nextmove Technology',
    },
    {
        Id: '4',
        sIcon: Huawei,
        title: 'Huawei',
    },
    {
        Id: '5',
        sIcon: Maipu,
        title: 'Maipu',
    },
    {
        Id: '6',
        sIcon: Indosat,
        title: 'Indosat',
    },
    {
        Id: '7',
        sIcon: Moratelindo,
        title: 'Moratelindo',
    },
    {
        Id: '8',
        sIcon: iconplus,
        title: 'Icon +',
    },
    {
        Id: '9',
        sIcon: TerraNet,
        title: 'Terra Net',
    },
    {
        Id: '10',
        sIcon: CGSwarna,
        title: 'CGS'
    },
    {
        Id: '11',
        sIcon: OMNIA,
        title: 'Omnia Tekonologi Indonesia',
    },
    {
        Id: '12',
        sIcon: Holowits,
        title: 'Holowits',
    },
    {
        Id: '13',
        sIcon: Ceragon,
        title: 'Ceragon',
    },
    {
        Id: '14',
        sIcon: iso_9001,
        title: 'ISO 9001 Quality Management System',
    },
    {
        Id: '15',
        sIcon: ISO_45001,
        title: 'ISO 45001 Occupational Health And Safety Management System',
    },
    {
        Id: '16',
        sIcon: ISO_14001,
        title: 'ISO 14001 Environmental Management System',
    },
    {
        Id: '17',
        sIcon: IDC_Duren_3,
        title: 'IDC Duren 3',
    },
    {
        Id: '18',
        sIcon: imageDefault,
        title: 'Cyber 1 Kuningan',
    },
    {
        Id: '19',
        sIcon: imageDefault,
        title: 'Dasen Surabaya',
    },
]


const TechnologySection = (props) => {

    const [activeTab, setActiveTab] = useState('1');

    const toggle = tab => {
        if (activeTab !== tab) setActiveTab(tab);
    }


    return (

        <div className="section_space">
            <div className="heading_block text-center">
                <div className="heading_focus_text has_underline d-inline-flex" style={{ backgroundImage: `url(${Bg})` }}>
                    Our Strong Point
                </div>
                <h2 className="heading_text mb-0">
                    {/* We Use <mark>Technologies</mark> */}
                    Our company has established strategic partnerships and obtained several ISO certifications, reinforcing our commitment to quality, compliance, and international standards.
                </h2>
            </div>

            <div className="tab_block_wrapper">
                <Nav tabs className="nav justify-content-center">
                    <NavItem>
                        <NavLink
                            className={classnames({ active: activeTab === '1' })}
                            onClick={() => { toggle('1'); }}
                        >
                            Partners
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: activeTab === '2' })}
                            onClick={() => { toggle('2'); }}
                        >

                            Certification
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: activeTab === '3' })}
                            onClick={() => { toggle('3'); }}
                        >

                            Data Center
                        </NavLink>
                    </NavItem>
                    {/* <NavItem>
                        <NavLink
                            className={classnames({ active: activeTab === '4' })}
                            onClick={() => { toggle('4'); }}
                        >

                            Mobile Apps
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: activeTab === '5' })}
                            onClick={() => { toggle('5'); }}
                        >

                            Other Frameworks
                        </NavLink>
                    </NavItem> */}
                </Nav>

                <TabContent activeTab={activeTab}>
                    <TabPane tabId="1">
                        <div className="web_development_technologies row justify-content-center">
                            {TechnologyList.slice(0, 13).map((technology, cnt) => (
                                <div className="col-lg-2 col-md-3 col-sm-4 col-6" key={cnt}>
                                    <div className="iconbox_block text-center p-0 shadow-none bg-transparent">
                                        <div className="iconbox_icon">
                                            <img src={technology.sIcon} alt="" style={technology.title === 'Maipu' ? { filter: 'brightness(0)' } : {}} />
                                        </div>
                                        <div className="iconbox_content">
                                            <h3 className="iconbox_title mb-0">{technology.title}</h3>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </TabPane>
                    <TabPane tabId="2">
                        <div className="web_development_technologies row justify-content-center">
                            {TechnologyList.slice(13, 16).map((technology, cnt) => (
                                <div className="col-lg-2 col-md-3 col-sm-4 col-6" key={cnt}>
                                    <div className="iconbox_block text-center p-0 shadow-none bg-transparent">
                                        <div className="iconbox_icon">
                                            <img src={technology.sIcon} alt="" />
                                        </div>
                                        <div className="iconbox_content">
                                            <h3 className="iconbox_title mb-0">{technology.title}</h3>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </TabPane>
                    <TabPane tabId="3">
                        <div className="web_development_technologies row justify-content-center">
                            {TechnologyList.slice(16, 19).map((technology, cnt) => (
                                <div className="col-lg-2 col-md-3 col-sm-4 col-6" key={cnt}>
                                    <div className="iconbox_block text-center p-0 shadow-none bg-transparent">
                                        <div className="iconbox_icon">
                                            <img src={technology.sIcon} alt="" />
                                        </div>
                                        <div className="iconbox_content">
                                            <h3 className="iconbox_title mb-0">{technology.title}</h3>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </TabPane>
                </TabContent>
            </div>
        </div>
    )
}

export default TechnologySection;
